import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar, Cell } from "recharts";
import { CustomTooltip } from "./CustomTooltip";

export const QuarterlyComparison = ({ quarterlyData }) => {
  if (!quarterlyData || !quarterlyData.quarters || quarterlyData.quarters.length === 0) {
    return (
      <div className="bg-[#0d0d0f] rounded-xl border border-gray-800 p-6">
        <h3 className="text-lg font-semibold text-white mb-4">Comparativa Trimestral</h3>
        <p className="text-gray-500">No hay datos trimestrales disponibles</p>
      </div>
    );
  }

  return (
    <div className="bg-[#0d0d0f] rounded-xl border border-gray-800 p-6">
      <h3 className="text-lg font-semibold text-white mb-4">Comparativa Trimestral</h3>
      {quarterlyData.quarters.length > 1 && (
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-4">
            <p className="text-gray-400 text-sm mb-1">Mejor Trimestre</p>
            <p className="text-emerald-400 font-bold text-lg">{quarterlyData.best_quarter?.quarter}</p>
            <p className="text-emerald-400 text-sm">+{quarterlyData.best_quarter?.total_pnl?.toFixed(2)} USDT</p>
          </div>
          <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4">
            <p className="text-gray-400 text-sm mb-1">Peor Trimestre</p>
            <p className="text-red-400 font-bold text-lg">{quarterlyData.worst_quarter?.quarter}</p>
            <p className="text-red-400 text-sm">{quarterlyData.worst_quarter?.total_pnl?.toFixed(2)} USDT</p>
          </div>
        </div>
      )}
      <div className="h-64 mb-6">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={quarterlyData.quarters}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1f1f23" />
            <XAxis dataKey="quarter" stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 11 }} />
            <YAxis stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 11 }} />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="total_pnl" name="PNL Trimestral">
              {quarterlyData.quarters.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.total_pnl >= 0 ? '#10b981' : '#ef4444'} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-800">
              <th className="text-left py-3 text-gray-400 font-medium">Trimestre</th>
              <th className="text-right py-3 text-gray-400 font-medium">PNL</th>
              <th className="text-right py-3 text-gray-400 font-medium">Trades</th>
              <th className="text-right py-3 text-gray-400 font-medium">Win Rate</th>
              <th className="text-right py-3 text-gray-400 font-medium">Volumen</th>
            </tr>
          </thead>
          <tbody>
            {quarterlyData.quarters.map((q) => (
              <tr key={q.quarter} className="border-b border-gray-800/50">
                <td className="py-3 text-white font-medium">{q.quarter}</td>
                <td className={`py-3 text-right font-semibold ${q.total_pnl >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                  {q.total_pnl >= 0 ? '+' : ''}{q.total_pnl.toFixed(2)} USDT
                </td>
                <td className="py-3 text-right text-gray-300">{q.trades}</td>
                <td className="py-3 text-right text-gray-300">{q.win_rate}%</td>
                <td className="py-3 text-right text-gray-300">{(q.volume / 1000000).toFixed(2)}M</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
